import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setUrls, getUrls } from '../../redux/slices/chatbotSlice';

const WaitForVideo = ({ triggerNextStep }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const urlSelector = useSelector(getUrls);

  const captureVideo = async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        preferCurrentTab: true,
        video: true,
      });

      return new Promise((resolve, reject) => {
        try {
          const data = [];
          const mediaRecorder = new MediaRecorder(stream);

          mediaRecorder.ondataavailable = e => {
            data.push(e.data);
          };

          mediaRecorder.start();
          mediaRecorder.onstop = e => {
            const blob = new Blob(data, { type: 'video/webm' });
            resolve(blob);
          };
        } catch (error) {
          reject(error);
        }
      });
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    const getMediaUrl = async () => {
      const blob = await captureVideo();
      if (blob) {
        dispatch(setUrls([blob]));
        triggerNextStep({ trigger: '6' });
      } else {
        if (urlSelector.length > 0) {
          triggerNextStep({ trigger: '6' });
        } else {
          triggerNextStep({ trigger: 'no-screen' });
        }
      }
    };
    getMediaUrl();
  }, []);

  return <div>{t('botWaitForVideo')}</div>;
};

export default WaitForVideo;
